* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: 2px;
}

gz-link {
  padding-top: calc(var(--spacer) * 10);
}
